export default "__VITE_ASSET__babae368__"